<template>
  <v-form>
    <v-container>
      <div style="height: 10px;"></div>
      
      <v-layout row wrap>
        <v-flex xs12>
          <v-select
            v-model="selectCategory"
            :items="itemCategories"
            label="商品カテゴリ"
            item-text="itemCategoryName"
            item-value="itemCategoryId"
            :sort-by="['itemCategoryId']"
            :sort-desc="[false]"
            return-object
            style="width: 100%;"
          ></v-select>
        </v-flex>
      </v-layout>
      
      <div style="height: 20px;"></div>
      <v-data-table
        :headers="headers"
        :items="items"
        item-key="itemCode"
        class="elevation-1"
        hide-actions
        :customFilter="customFilter"
        :search="selectCategory"
        :custom-sort="customSort"
      >
        <template slot="headerCell" slot-scope="props">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <span v-on="on">{{ props.header.text }}</span>
            </template>
            <span>{{ props.header.text }}</span>
          </v-tooltip>
        </template>

        <template v-slot:items="props">
          <tr>
            <td class="text-xs-left" style="width: 30px;" >
              <v-checkbox 
                v-model="props.item.isChecked" 
                primary 
                hide-details 
                @change="itemCheck(props.item)">
              </v-checkbox>
            </td>
            <td class="text-xs-left">{{ props.item.itemCategoryName }}</td>
            <td class="text-xs-left">{{ props.item.itemName }}</td>
            <td class="text-xs-left">{{ props.item.janCode }}</td>
            <td class="text-xs-right">{{ Number(props.item.unitPrice || 0).toLocaleString() }}</td>
          </tr>
        </template>
      </v-data-table>
      <br />
      
      <div class="footer-btns">
        <v-btn block color="#4C728A" dark :to="{ name: 'admin/new-admin-menu' }">
          <v-icon color="black" left>home</v-icon>Home
        </v-btn>
        <v-btn block class="ma-2" color="success" @click="forwardStoreItemDisplayRegist()" >
          <v-icon dark left>save</v-icon>非表示に登録する
        </v-btn>
        <v-btn block class="ma-2" color="red" @click="forwardStoreItemDisplayDelete()" >
          <v-icon dark left>save</v-icon>表示のため削除する
        </v-btn>
      </div>
    </v-container>
  </v-form>
</template>

<script>
import { mapState } from 'vuex'
import ServerApiCallService from '@/services/ServerApiCallService.js'

export default {
  created() {
    this.getAllItems()
  },
  methods: {
    customSort(items) {
      return [...items].sort((a, b) => {
        if (a.itemCategoryId < b.itemCategoryId) return -1
        if (a.itemCategoryId > b.itemCategoryId) return 1
        if (a.itemName < b.itemName) return -1
        if (a.itemName > b.itemName) return 1
        return 0
      })
    },
    getAllItems() {
      let thisObj = this

      ServerApiCallService.itemCategories()
        .then(response => {
          console.log('completed item categories')
          thisObj.itemCategories = response.data.itemCategories
          thisObj.itemCategories.unshift({
            itemCategoryId: '#',
            itemCategoryName: '全て'
          })
        })
        .catch(error => {
          console.log('There was an error:', error.response)
        })

      ServerApiCallService.displayStoreItems2()
        .then(response => {
          thisObj.items = (response.data.items || []).map(it => ({
          ...it,
          isChecked: false,
          }))

        })
        .catch(error => {
          console.log('There was an error:', error.response)
        })
    },
    customFilter(items, search) {
      if (search.itemCategoryName === '全て') {

        return this.customSort(items)
      } else {
        let filteringItems = items.filter(function(value) {
          if (value.itemCategoryId === search.itemCategoryId) {
            return true
          } else {
            return false
          }
        })

        return this.customSort(filteringItems)
      }
    },
    itemCheck(itemInfo) {
      // isChecked는 v-model이 이미 바꿔줌 (@change 시점)
      const code = itemInfo.itemCode;

      // 체크된 상태 → 선택 배열에 추가
      if (itemInfo.isChecked) {
        // 선택 추가 (중복 방지)
        if (!this.selectedItems.some(x => x.itemCode === code)) {
          this.selectedItems.push(itemInfo);
        }
      } else {
        // 체크 해제 → 선택 배열에서 제거
        this.selectedItems = this.selectedItems.filter(x => x.itemCode !== code);
      }
    },    
    forwardStoreItemDisplayRegist() {
      // 점포를 선택하지 않았을때
      if (this.selectedItems.length === 0) {        
        this.$parent.$parent.$parent.showErrorDialog(
          '商品を選択してください'
        )
        return
      }

      // 선택한 상품을 sesseion에 등록
      sessionStorage.setItem("param", JSON.stringify(this.selectedItems));
      // 등록 페이지에 이동
      this.$router.push({name: 'admin-display-store-items-regist3'})
    },
    forwardStoreItemDisplayDelete() {
      // 상품을 선택하지 않았을때
      if (this.selectedItems.length === 0) {        
        this.$parent.$parent.$parent.showErrorDialog(
          '商品を選択してください'
        )
        return
      }

      // 선택한 상품을 sesseion에 등록
      sessionStorage.setItem("param", JSON.stringify(this.selectedItems));
      // 삭제 페이지에 이동
      this.$router.push({name: 'admin-display-store-items-delete3'})
    },    
  },
  computed: {
    ...mapState({
      user: state => state.admin
    }),
    selectCategory: {
      get() {
        return this.$store.state.adminSession.selectCategory
      },
      set(value) {
        this.$store.commit('SET_SELECTED_ITEM_CATEGORY', value)
      }
    }
  },
  data() {
    return {
      loader: null,
      items: [],
      itemCategories: [],
      selectedItems: [],
      checkbox: null,
      headers: [
        {
          text: '選択',
          align: 'left',
          value: 'selectSupplier',
          width: '30px',
          fixed: true,
          sortable: false
        },
        {
          text: 'カテゴリ',
          align: 'left',
          value: 'itemCategoryName',
          width: '150px',
          sortable: false
        },
        {
          text: '商品名',
          align: 'left',
          value: 'itemName',
          width: '150px',
          sortable: false
        },
        {
          text: 'JANコード',
          align: 'left',
          value: 'janCode',
          width: '30px',
          sortable: false
        },
        {
          text: '単価',
          align: 'center',
          value: 'unitPrice',
          width: '30px',
          sortable: false
        },
      ]
    }
  }
}
</script>

<style>
.column-input {
  width: 100% !important;
  height: 30px;
  text-align: right;
  border: 1px solid #c7c7c7;
  padding: 0 4px;
}
.deleted-class-name {
  background-color: #b3b3b3;
}
.footer-btns {
  position: sticky;         /* 스크롤해도 하단 고정 */
  bottom: 0;                /* 컨테이너의 맨 아래 */
  display: flex;
  justify-content: space-between; /* 버튼 사이 일정 간격 */
  gap: 8px;                 /* 버튼들 사이 여백 */
  width: 100%;              /* 테이블 폭과 동일 */
  background: white;        /* 버튼 뒤 배경 */
  padding: 10px 0;          /* 위아래 여백 */
  z-index: 1000;
}
.footer-btns .v-btn {
  flex: 1;                  /* 버튼들이 같은 폭 */
}
</style>
